export const cameraView08DeckWheelsImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 08 - Deck Wheels',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    SprayHood: 1,
    Boom: 1,
    MastAndBoom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView08DeckWheels.js